module.exports = __webpack_public_path__ + "img/Afghanistan.ff7da182.svg";